"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.entry.reasoning': 'Razonamiento',
};
